import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../../core/environment/environment.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../core/environment/environment.service";
var ErrorService = /** @class */ (function () {
    function ErrorService(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
        this.serviceUrl = './assets/message/errorMessage.json';
    }
    ErrorService.prototype.getErrorMessage = function () {
        return (this.http.get(this.serviceUrl));
    };
    ErrorService.prototype.getUrlInitialPage = function () {
        return this.environmentService.envModel.initialPage;
    };
    ErrorService.ngInjectableDef = i0.defineInjectable({ factory: function ErrorService_Factory() { return new ErrorService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService)); }, token: ErrorService, providedIn: "root" });
    return ErrorService;
}());
export { ErrorService };
